import React, { FC } from "react";
import cx from "classnames";

import { IconButton } from "~/ui-kit/components/IconButton/IconButton";
import { BackIcon } from "~/ui-kit/icons/Back";
import { HorizontalRule } from "~/ui-kit/components/HorizontalRule/HorizontalRule";
import { Typography } from "~/ui-kit/components/Typography/Typography";
import { emptyCallback } from "~/util/emptyCallback";

import "./SubHeader.scss";

export type SubHeaderProps = {
  title: string;
  subTitle?: string;
  hasBackBtn?: boolean;
  onBackBtnClick?: () => void;
  isBackBtnDisabled?: boolean;
};

export const SubHeader: FC<SubHeaderProps> = ({
  title,
  subTitle,
  hasBackBtn = false,
  onBackBtnClick = emptyCallback,
  isBackBtnDisabled = false,
}) => {
  return (
    <>
      <div
        className={cx({ "d-flex align-items-center": hasBackBtn }, "px-3 pb-3")}
      >
        {hasBackBtn ? (
          <IconButton
            onClick={onBackBtnClick}
            variant="secondary"
            size="md"
            className="me-2 p-0"
            disabled={isBackBtnDisabled}
          >
            <BackIcon />
          </IconButton>
        ) : null}

        <div className="d-flex flex-column align-items-center w-100">
          <Typography
            className="grey-900-c text-center sub-header-title"
            size="xl"
            weight="bd"
          >
            {title}
          </Typography>
          {subTitle ? (
            <Typography
              className="grey-500-c text-center"
              size="sm"
              weight="rg"
            >
              {subTitle}
            </Typography>
          ) : null}
        </div>
      </div>
      <HorizontalRule className="mt-3 mb-0" />
    </>
  );
};
